const Permissions = {
  SURVEILLANCE: "surveillance en direct",
  HISTORIQUE_NAVIGATION: "historique de navigation",
  HISTORIQUE_INSTALLATIONS: "historique des installations",

  HISTORIQUE_60J_SURVEILLANCE: "historique 60j surveillance",
  BLOCAGE_APPLICATIONS_SITES: "blocage applications sites",
  ALERTE_INACTIVITE_30MIN: "alerte inactivite 30min",
  CAPTURE_CLAVIER: "capture clavier(keylogger)",

  SURVEILLANCE_OPERATEUR: "surveillance operateur",
  COMPTE_RENDU_JOURNALIER: "compte rendu journalier",
};


export default Permissions;
